function handleMenu() {
	var menu = document.getElementById('js-mobile-menu');
	var menuTrigger = document.getElementById('js-menu-trigger');
	var body = document.body;

	menuTrigger.addEventListener('click', function(e) {
		e.preventDefault();
		menu.classList.toggle('open');
		menuTrigger.classList.toggle('active');
		body.classList.toggle('overflow-hidden');
	});
}

handleMenu();

function counsellingMenu() {
	var modal = document.getElementById('js-counselling-menu');
	var modalTrigger = document.querySelectorAll('.counselling-trigger');
	var body = document.body;

	modalTrigger.forEach(function(el) {
		el.addEventListener('click', function(e) {
			modal.classList.toggle('open');
			body.classList.toggle('overflow-hidden');
		});
	});
}

counsellingMenu();

function siteMenu() {
	var modal = document.getElementById('js-site-selector-menu');
	var modalTrigger = document.getElementById('js-site-selector-trigger');
	var body = document.body;

	modalTrigger.addEventListener('click', function(e) {
		modal.classList.toggle('open');
		modalTrigger.classList.toggle('open');
	});
}

siteMenu();

function loginMenu() {
	var modal = document.getElementById('js-login-menu');
	var modalTrigger = document.querySelectorAll('.login-trigger');
	var body = document.body;

	modalTrigger.forEach(function(el) {
		el.addEventListener('click', function(e) {
			modal.classList.toggle('open');
			body.classList.toggle('overflow-hidden');
		});
	});
}

loginMenu();

function search() {
	var modal = document.getElementById('js-search');
	var modalTrigger = document.querySelectorAll('.search-trigger');
	var body = document.body;

	modalTrigger.forEach(function(el) {
		el.addEventListener('click', function(e) {
			modal.classList.toggle('open');
			body.classList.toggle('overflow-hidden');
		});
	});
}

search();

if (document.getElementById('js-submenu')) {
	function subMenu() {
		var modal = document.getElementById('js-submenu');
		var modalTrigger = document.getElementById('js-submenu-trigger');

		modalTrigger.addEventListener('click', function(e) {
			modal.classList.toggle('open');
		});
	}

	subMenu();
}
